/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useContext, useEffect } from "react"
import { Dialog, Transition } from "@headlessui/react"
import { graphql, useStaticQuery } from "gatsby"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import SearchIcon from "../icons/search"
import Link from "./link"
import slugify from "../utils/slugify"

export default function SearchModal(): JSX.Element {
  const { searchOpen, setSearchOpen, searchTerm, setSearchTerm } =
    useContext(UserInterfaceContext)

  function closeSearch(): void {
    setSearchOpen(false)
    setSearchTerm(``)
  }

  useEffect(() => {
    window.addEventListener(
      `keypress`,
      e => {
        if (
          e.key === `/` &&
          !searchOpen &&
          (document.activeElement.id === `gatsby-focus-wrapper` ||
            document.activeElement === document.body)
        ) {
          setSearchOpen(true)
        }
      },
      true
    )
  }, [])

  const [searchForNothing, setSearchForNothing] = React.useState<boolean>(false)

  return (
    <Fragment>
      <button
        title="shortcut: /"
        onClick={(): void => setSearchOpen(true)}
        className="p-3"
      >
        <SearchIcon className="w-4 h-4 lg:w-6 lg:h-6" />
      </button>
      <Transition.Root show={searchOpen} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto"
          open={searchOpen}
          onClose={closeSearch}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6 lg:max-w-[50%]">
                <form
                  action="/search/"
                  id="searchbox_000080029827298702691:wvthyjesm5m"
                  className="form-inline float-sm-right"
                  onSubmit={e => {
                    if (searchTerm === ``) {
                      e.preventDefault()
                      setSearchForNothing(true)
                      // reset in 5 seconds
                      setTimeout(() => setSearchForNothing(false), 5000)
                    }
                  }}
                >
                  <div className="input-append">
                    <input
                      type="hidden"
                      name="cx"
                      value="000080029827298702691:wvthyjesm5m"
                    />
                    <input type="hidden" name="cof" value="FORID:11" />
                    <div className="flex gap-2 items-center ">
                      <input
                        onChange={e => {
                          setSearchTerm(e.target.value.toLowerCase())
                        }}
                        id="georgianSearch"
                        name="q"
                        className="border-2 border-lightgray text-xl w-full p-2"
                        type="text"
                        placeholder="What are you looking for?"
                        aria-label="Search the Georgian College website"
                      />
                      <button
                        id="searchSubmit"
                        className="flex gap-2 items-center px-4 py-3 bg-blue hover:bg-green text-white"
                        type="submit"
                      >
                        <SearchIcon className="w-4 h-4" />
                        <span className="hidden-xs">Search</span>
                      </button>
                    </div>
                    {searchForNothing && (
                      <div className="mt-2 alerts-container bg-red-100 text-black px-4 py-2 text-sm">
                        Please enter a search term.
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </Fragment>
  )
}
